<template>
  <div class="home-quick-nav">
    <div class="nav-card blue-card" @click="goToRegProcess">
      <img :src="require('@/assets/home/icon-baoming.png')" class="icon" />
      <div class="content">
        <div class="title">报名流程</div>
        <div class="subtitle">点击查看详细报名步骤与所需材料</div>
      </div>
    </div>
    <div class="nav-card green-card" @click="goToRules">
      <img :src="require('@/assets/home/icon-guiding.png')" class="icon" />
      <div class="content">
        <div class="title">管理规定</div>
        <div class="subtitle">点击查看培训班培训管理规定</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeQuickNav",
  methods: {
    goToRegProcess() {
      this.$emit("go-reg-process");
    },
    goToRules() {
      this.$emit("go-rules");
    }
  }
};
</script>

<style scoped lang="scss">
.home-quick-nav {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  margin: 24px auto 0;

  .nav-card {
    width: 510px;
    height: 90px;
    border-radius: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px;
    box-shadow: 0 5px 12px -3px rgba(0, 0, 0, 0.2);
    transition: all 0.3s;
    position: relative;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
    }

    .content {
      flex: 1;
      margin-left: 30px;
    }

    .title {
      font-size: 24px;
      font-weight: 700;
      margin-bottom: 4px;
      text-align: left;
      // transform: scale(0.6);
      // transform-origin: left center;
      // white-space: nowrap;
      // line-height: 1;
    }

    .subtitle {
      font-size: 14px;
      margin-top: -4px;
      text-align: left;
    }

    .icon {
      width: 48px;
      height: 48px;
      margin-left: 20px;
    }

    &.blue-card {
      background: #f1f6ff;
      .title {
        color: #283fa9;
      }
      .subtitle {
        color: #283fa9;
        opacity: 0.8;
      }
    }

    &.green-card {
      background: #eef8f2;
      .title {
        color: #316439;
      }
      .subtitle {
        color: #316439;
        opacity: 0.8;
      }
    }
  }
}
</style>
